

















































    
import {Vue, Component, Mixins, Prop, Watch} from 'vue-property-decorator';
import { Client, ClientProject, ClientProjectCreate, ClientProjectStatus, ClientService, CLIENT_PROJECT_STATUS_NAMES } from '../../../services/accounting.service';
import { FormMixin } from './../../../mixins/FormMixin'

@Component({})
export default class ClientProjectForm extends Mixins<FormMixin<ClientProjectCreate, ClientProject>>(FormMixin) {

    clients: Client[] = [];
    clientsApi: ClientService = new ClientService();

    empty: ClientProjectCreate = {
        title: '',
        status: ClientProjectStatus.LEAD,
        clientId: '',
    }

    created() {
        this.refreshClients();
    }

    async refreshClients() {
        const res = await this.clientsApi.get();
        if (res.success) {
            this.clients = res.result;
        }
    }

    objToDto = (obj: ClientProject) => {
        return {
            title: obj.title,
            status: obj.status,
            clientId: obj.client.id,
        }
    }

    idFn = (obj: ClientProject) => {
        return obj.id;
    }

    get statuses() {
        return CLIENT_PROJECT_STATUS_NAMES;
    }
}

